import { useEffect, useState } from 'react'
import {
  FaBell,
  FaBullhorn,
  FaChartLine,
  FaClock,
  FaCloudArrowUp,
  FaGavel,
  FaMagnifyingGlass,
  FaPlus,
  FaRightFromBracket,
  FaShieldHalved,
} from 'react-icons/fa6'
import logo from '../../images/logo.png'
import { ROUTE_PATHS, dashboardRoute, navigateTo } from '../../app/routes'
import { clearSession } from '../../services/authStorage'
import { adminNav, getAdminDescription } from './adminConfig'

function AdminUsClock() {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 1000)
    return () => window.clearInterval(timer)
  }, [])

  const time = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'America/Los_Angeles',
  }).format(now).toLowerCase()

  const date = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    weekday: 'long',
    year: 'numeric',
    timeZone: 'America/Los_Angeles',
  }).format(now)

  return (
    <div className="obc-admin-clock" aria-label={`Current California time ${date} ${time} GMT-7`}>
      <FaClock />
      <div>
        <span>California, USA</span>
        <strong>{time}</strong>
        <small>{date} (GMT-7)</small>
      </div>
    </div>
  )
}

export function AdminSidebar({ activeSection, onSectionChange }) {
  const handleLogout = () => {
    clearSession()
    navigateTo('/login')
  }

  return (
    <aside className="obc-dashboard__sidebar">
      <button className="obc-dashboard__logo" type="button" onClick={() => onSectionChange('overview')}>
        <img className="obc-dashboard__logo-img" src={logo} alt="OBC Cards and Collectibles" />
      </button>

      <div className="obc-admin-sidebar__status">
        <span>Operations Console</span>
        <strong>Secure</strong>
      </div>

      <nav className="obc-dashboard__nav" aria-label="Admin workspace navigation">
        <span className="obc-admin-sidebar__nav-label">Workspace</span>
        {adminNav.map((item) => (
          <button
            className={activeSection === item.id ? 'is-active' : undefined}
            type="button"
            onClick={() => onSectionChange(item.id)}
            key={item.id}
          >
            {item.icon}
            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="obc-dashboard__operator">
        <div className="obc-dashboard__avatar">
          <FaShieldHalved />
        </div>
        <div>
          <span>Signed in as</span>
          <strong>Marketplace Ops</strong>
        </div>
      </div>

      <button className="obc-dashboard__logout" type="button" onClick={handleLogout}>
        <FaRightFromBracket />
        Log Out
      </button>
    </aside>
  )
}

export function AdminTopbar({ activeLabel, onSectionChange }) {
  return (
    <header className="obc-dashboard__topbar">
      <h2>{activeLabel}</h2>
      <label className="obc-dashboard__search">
        <FaMagnifyingGlass />
        <input placeholder="Search users, lots, orders, consignments..." type="text" />
      </label>
      <AdminUsClock />
      <div className="obc-dashboard__top-actions">
        <button type="button" aria-label="Upload images" onClick={() => onSectionChange('auctions')}>
          <FaCloudArrowUp />
        </button>
        <button type="button" aria-label="Notifications" onClick={() => onSectionChange('notifications')}>
          <FaBell />
          <span />
        </button>
        <div className="obc-dashboard__user">
          <span>Admin</span>
          <strong>Operations</strong>
        </div>
      </div>
    </header>
  )
}

export function AdminHero({ activeLabel, activeSection, onSectionChange }) {
  return (
    <section className="tactical-card obc-admin__hero">
      <div>
        <span className="obc-dashboard__kicker">
          <FaChartLine />
          Operations control room
        </span>
        <h1>{activeLabel}</h1>
        <p>{getAdminDescription(activeSection)}</p>
      </div>
      <div className="obc-admin__hero-actions">
        <button type="button" onClick={() => onSectionChange('auctions')}><FaPlus /> Auction</button>
        <button type="button" onClick={() => onSectionChange('shop')}><FaPlus /> Listing</button>
        <button type="button" onClick={() => onSectionChange('content')}><FaBullhorn /> Feature</button>
      </div>
    </section>
  )
}

export function navigateAdminSection(section) {
  navigateTo(dashboardRoute(ROUTE_PATHS.admin, section))
}
